import callAPI from "../callApi";
import path from "../variables";

const Notifications = {
	getAll: (unreadOnly = false, limit = 50) =>
		callAPI(
			"GET",
			`${path.base}/notifications?unread=${unreadOnly ? "true" : "false"}&limit=${limit}`,
			"",
			"listing notifications"
		),
	unreadCount: () =>
		callAPI("GET", `${path.base}/notifications/unread-count`, "", "unread notifications count"),
	markRead: (id: number) =>
		callAPI("POST", `${path.base}/notifications/${id}/read`, {}, "marking notification read"),
	markAllRead: () =>
		callAPI("POST", `${path.base}/notifications/mark-all-read`, {}, "marking all notifications read"),
	remove: (id: number) =>
		callAPI("DELETE", `${path.base}/notifications/${id}`, "", "removing notification"),
};

export default Notifications;
